import { DataTableProps } from '@warrenbrasil/nebraska-web';
import { InstrumentNameCell } from '@/modules/trade/components/InstrumentNameCell';
import { MultiRiskCell } from '@/modules/catalog/components/MultiRiskCell';

const productLabel = (products: number) => {
  return products > 1 ? `${products} Produtos` : `${products} Produto`;
};

export const columns = (products: number): DataTableProps.Column[] => {
  return [
    {
      label: productLabel(products),
      component: InstrumentNameCell,
      sort: 'BaseAsset.Name',
      width: '20%',
      getter: ({ name, category }) => ({
        symbol: name,
        name: category,
        size: 'small',
        hasEllipsis: true
      })
    },
    {
      label: 'Mínimo inicial',
      align: DataTableProps.Align.Right,
      sort: 'MinimumInvestmentQuantity',
      width: '15%',
      getter: 'minimumInvestment'
    },
    {
      label: 'Ganho máximo',
      align: DataTableProps.Align.Right,
      sort: 'MaximumReturn',
      width: '15%',
      getter: 'maxGain'
    },
    {
      label: 'Risco máximo',
      align: DataTableProps.Align.Right,
      sort: 'MaximumRiskValue',
      width: '15%',
      getter: 'maxRisk'
    },
    {
      label: 'Vencimento',
      align: DataTableProps.Align.Right,
      sort: 'MaturityDate',
      width: '15%',
      getter: 'maturityDate'
    },
    {
      label: 'Características',
      component: MultiRiskCell,
      align: DataTableProps.Align.Right,
      width: '20%',
      getter: ({ chips }) => ({
        risks: chips
      })
    }
  ];
};
